import { useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import qs from 'qs';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';

import ReadLinkableDevicesCommand from 'features/device/linkable-device/domain/models/read-linkable-devices-command';
import ReadLinkableDevicesResponse from 'features/device/linkable-device/domain/models/read-linkable-devices-response';
import ReadLinkableTransmittersQuery from 'features/device/linkable-transmitters/domain/models/read-linkable-transmitters-query';
import ReadLinkableTransmittersResponse from 'features/device/linkable-transmitters/domain/models/read-linkable-transmitters-response';

const baseUrlV2 = '/api/v2/device';

enum QueryPaths {
  GetLinkableDevices = 'GetLinkableDevices',
  GetLinkableTransmitters = 'GetLinkableTransmitters',
}

const readLinkableDevices = async (
  axiosInstance: AxiosInstance,
  command: ReadLinkableDevicesCommand,
): Promise<ReadLinkableDevicesResponse> => {
  const response = await axiosInstance.post(`${baseUrlV2}/${QueryPaths.GetLinkableDevices}`, command);
  return response.data;
};

const readLinkableTransmitters = async (
  axiosInstance: AxiosInstance,
  query: ReadLinkableTransmittersQuery,
): Promise<ReadLinkableTransmittersResponse> => {
  const queryString = qs.stringify(query, { allowDots: true });
  const response = await axiosInstance.get(`${baseUrlV2}/${QueryPaths.GetLinkableTransmitters}?${queryString}`);
  return response.data;
};

export const useReadLinkableDevices = () => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useMutation({
    mutationKey: [QueryPaths.GetLinkableDevices],
    mutationFn: (command: ReadLinkableDevicesCommand) => readLinkableDevices(authenticatedInstance, command),
  });
};

export const useReadLinkableTransmitters = () => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useMutation({
    mutationKey: [QueryPaths.GetLinkableTransmitters],
    mutationFn: (query: ReadLinkableTransmittersQuery) => readLinkableTransmitters(authenticatedInstance, query),
  });
};
